import { createTypes } from '../../utils/helpers';

const CATEGORIES_FETCH_CATEGORIES: any = createTypes(
  'CATEGORIES_FETCH_CATEGORIES',
);
const CATEGORIES_FETCH_CATEGORIES_CATALOG: any = createTypes(
  'CATEGORIES_FETCH_CATEGORIES_CATALOG',
);
const CATEGORIES_FETCH_CATEGORIES_BY_NAME: any = createTypes(
  'CATEGORIES_FETCH_CATEGORIES_BY_NAME',
);
const CATEGORIES_CREATE_CATEGORY: any = createTypes(
  'CATEGORIES_CREATE_CATEGORY',
);
const CATEGORIES_EDIT_CATEGORY: any = createTypes('CATEGORIES_EDIT_CATEGORY');
const CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG: any = createTypes(
  'CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG',
);
const CATEGORIES_SET_ROWS_PER_PAGE = 'CATEGORIES_SET_ROWS_PER_PAGE';
const CATEGORIES_SET_PAGE = 'CATEGORIES_SET_PAGE';
const CATEGORY_CLEAR_PAGINATION_INFO = 'CATEGORY_CLEAR_PAGINATION_INFO';
export {
  CATEGORIES_FETCH_CATEGORIES,
  CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG,
  CATEGORIES_SET_PAGE,
  CATEGORIES_SET_ROWS_PER_PAGE,
  CATEGORIES_CREATE_CATEGORY,
  CATEGORIES_EDIT_CATEGORY,
  CATEGORIES_FETCH_CATEGORIES_CATALOG,
  CATEGORIES_FETCH_CATEGORIES_BY_NAME,
  CATEGORY_CLEAR_PAGINATION_INFO,
};
